<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-16 10:14:18
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-10-19 11:19:34
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-switch.vue
 * @Description: 描述
 -->


<template>
  <div :title="text"
    widget-type="switch">
    <a-switch v-model="text"
      :size="size"
      :data-model="fieldName"
      :disabled="disabled"
      :placeholder="disabled?'':placeholder"
      :class="options.customClass"
      @change="handleChange" />
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        defaultValue: false,
        required: false,
        disabled: false,
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        remoteFunc: '',
        remoteOption: '',
      },
    };
  },
  methods: {
    initVal(val) {
      if (val === undefined || val === null) {
        this.text = this.defaultValue;
      } else {
        this.text = val;
      }
    },
    handleChange(val) {
      const newVal = val;
      if (!this.isNested) {
        const { rowIndex, fieldName: field } = this;
        const value = {
          type: 'switch',
          rowIndex,
          field,
          value: newVal,
        };
        // this.dispatch('wgForm', 'on-change', value);
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      }
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', newVal);
    },
  },
};
</script>
